/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserMeResponse
 */
export interface RevisdomAPIViewModelsUserMeResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    unreadNotificationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    role?: RevisdomAPIViewModelsUserMeResponseRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    organizationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    notificationToEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsUserMeResponse
     */
    lastLoginAt?: Date | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsUserMeResponseRoleEnum = {
    AccountManager0: 'Account Manager (0)',
    AccountOwner1: 'Account Owner (1)',
    InternalTeam2: 'Internal Team (2)',
    BrandAccountViewer3: 'Brand Account Viewer (3)',
    SperYnetici4: 'Süper Yönetici (4)',
    Guest5: 'Guest (5)'
} as const;
export type RevisdomAPIViewModelsUserMeResponseRoleEnum = typeof RevisdomAPIViewModelsUserMeResponseRoleEnum[keyof typeof RevisdomAPIViewModelsUserMeResponseRoleEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsUserMeResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserMeResponse(value: object): value is RevisdomAPIViewModelsUserMeResponse {
    return true;
}

export function RevisdomAPIViewModelsUserMeResponseFromJSON(json: any): RevisdomAPIViewModelsUserMeResponse {
    return RevisdomAPIViewModelsUserMeResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserMeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserMeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'unreadNotificationCount': json['unreadNotificationCount'] == null ? undefined : json['unreadNotificationCount'],
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'title': json['title'] == null ? undefined : json['title'],
        'role': json['role'] == null ? undefined : json['role'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'notificationToEmail': json['notificationToEmail'] == null ? undefined : json['notificationToEmail'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
    };
}

export function RevisdomAPIViewModelsUserMeResponseToJSON(json: any): RevisdomAPIViewModelsUserMeResponse {
    return RevisdomAPIViewModelsUserMeResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserMeResponseToJSONTyped(value?: RevisdomAPIViewModelsUserMeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unreadNotificationCount': value['unreadNotificationCount'],
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'title': value['title'],
        'role': value['role'],
        'organizationName': value['organizationName'],
        'thumbnailUrl': value['thumbnailUrl'],
        'notificationToEmail': value['notificationToEmail'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'lastLoginAt': value['lastLoginAt'] == null ? undefined : ((value['lastLoginAt'] as any).toISOString()),
    };
}

